/**
 * Module dependencies
 */

var Context = module.exports = require('./lib/context');
var Emitter = require('emitter-component');

/**
 * Mixin the emitter
 */

Emitter(Context.prototype);



//////////////////
// WEBPACK FOOTER
// ./node_modules/superagent-defaults/index.js
// module id = 968
// module chunks = 0 1